/**
 * Theo Teams teammate surfaces — gated by LaunchDarkly `teams-teammate`
 * (and camelCase / bracket variants commonly returned by `useFlags()`).
 */
export function isTeamsTeammateLdEnabled(flags: Record<string, unknown> | undefined): boolean {
  if (!flags || typeof flags !== "object") {
    return false;
  }
  const f = flags as Record<string, unknown>;
  return f.teamsTeammate === true || f.teamsteammate === true || f["teams-teammate"] === true;
}
